import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPiaProductAreasNir } from '../selectors';
import { fetchRaPaNir } from '../actions';
import { toJS } from 'utils/immutableUtils';
import { getConfigs } from 'features/app/selectors';
import { FranchiseType } from 'constants/franchiseType';

const useProductAreas = () => {
  const dispatch = useDispatch();
  //   const isFetching = useSelector(getIsFetching);
  const piaProductAreas = toJS(useSelector(getPiaProductAreasNir));
  const franchiseType = useSelector(getConfigs).toJS().franchise;

  useEffect(() => {
    if (!piaProductAreas.length && franchiseType !== FranchiseType.INGKA) {
      dispatch(fetchRaPaNir());
    }
  }, []);

  return [piaProductAreas];
};

export default useProductAreas;
